import { FormGroup } from "@mui/material";
import clone from "lodash.clonedeep";
import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { GROUP_TITLE_EN, GROUP_TITLE_RU, TITLE_EN, TITLE_RU } from "../constants";
import { initialRoleModel } from "../models";
import Tooltip from "../../../UI/Tooltip";
import FormControlLanguage from "../../../UI/FormControlLanguage";
import RoleListItem from "./RoleListItem";

const RoleCreateModal = (
    {
        eventRoles,
        isModalVisible,
        onSave,
        onEdit,
        onDelete,
        onClose,
    }
) => {
    const [model, setModel] = useState(null);
    const [roles, setRoles] = useState(null);
    const [isRolesListOpen, setRolesListOpen] = useState(true);

    useEffect(() => {
        setModel(clone(initialRoleModel));
    }, []);

    useEffect(() => {
        setRoles(eventRoles || []);
    }, [eventRoles]);

    const handleModelChange = (key, value) => {
        setModel({
            ...model,
            [key]: value,
        })
    };

    const handleModelSave = () => {
        if (!model?.[TITLE_RU] || (!model?.[TITLE_RU] && !model?.[TITLE_EN])) {
            alert('Введите название признака');

            return;
        }

        if ((model?.[TITLE_RU] && !model?.[GROUP_TITLE_RU]) || (model?.[TITLE_EN] && !model?.[GROUP_TITLE_EN])) {
            alert('Введите название признака для группы участников');

            return;
        }

        onSave(model);
        setModel(clone(initialRoleModel));
    }

    const handleModalClose = () => {
        setModel(clone(initialRoleModel));
        onClose();
    };

    return (
        <Modal
        bsSize="large"
            show={isModalVisible}
            onHide={handleModalClose}
        >
            <Modal.Header closeButton>
                <Modal.Title>Дополнительный признак</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup>
                    <FormControlLanguage
                        type="text"
                        placeholder="Введите название признака"
                        required
                        values={{
                            ru: model?.[TITLE_RU],
                            en: model?.[TITLE_EN],
                        }}
                        onChange={{
                            ru: (e) => handleModelChange(TITLE_RU, e.target.value),
                            en: (e) => handleModelChange(TITLE_EN, e.target.value),
                        }}
                    />
                </FormGroup>
                <FormGroup style={{ marginTop: '8px'}}>
                    <FormControlLanguage
                        type="text"
                        placeholder="Введите название признака для группы участников"
                        required
                        values={{
                            ru: model?.[GROUP_TITLE_RU],
                            en: model?.[GROUP_TITLE_EN],
                        }}
                        onChange={{
                            ru: (e) => handleModelChange(GROUP_TITLE_RU, e.target.value),
                            en: (e) => handleModelChange(GROUP_TITLE_EN, e.target.value),
                        }}
                    />
                </FormGroup>
                <p style={{marginTop: '4px'}}>
                    <i>
                        Для сохранения необходимо заполнить оба поля (на одном или на двух языках)
                    </i>
                </p>
                <p style={{marginTop: '20px', display: 'flex', columnGap: '12px'}}>
                    <Button onClick={handleModelSave}>
                        Сохранить в список
                    </Button>
                    <Button onClick={handleModalClose}>
                        Отмена
                    </Button>
                    {roles?.length > 0 && (
                        <Button onClick={() => setRolesListOpen(!isRolesListOpen)}>
                            {isRolesListOpen ? 'Скрыть' : 'Показать'} список
                        </Button>
                    )}
                </p>

                {isRolesListOpen && (
                    <Table>
                        <thead>
                            <tr>
                                <th style={{ width: '300px'}}>
                                    Название
                                </th>
                                <th style={{ width: '400px'}}>
                                    Название группы
                                    <Tooltip>
                                        Укажите название дополнительного признака во множественном числе
                                    </Tooltip>
                                </th>
                                <th style={{ width: '100px'}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!roles?.length && roles.map((role) => (
                                <RoleListItem
                                    key={role.id}
                                    role={role}
                                    onEdit={onEdit}
                                    onDelete={onDelete}
                                />
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );
};

export default RoleCreateModal;
